module.exports = __webpack_public_path__ + "img/03.3f853aa9.jpg";